export const qk = {
  employees: () => ['employees'] as const,
  employee: (id: string) => ['employees', id] as const,
  departments: () => ['departments'] as const,
  designations: () => ['designations'] as const,

  leaveTypes: () => ['leaveTypes'] as const,
  leaveRequests: (employeeId?: string) => employeeId ? ['leaveRequests', employeeId] : ['leaveRequests'] as const,
  leaveBalances: (employeeId: string) => ['leaveBalances', employeeId] as const,
  holidays: () => ['holidays'] as const,
  holidayCalendars: () => ['holidayCalendars'] as const,

  attendance: (employeeId: string) => ['attendance', employeeId] as const,
  shifts: () => ['shifts'] as const,

  documents: (employeeId: string) => ['documents', employeeId] as const,

  expenses: (employeeId: string) => ['expenses', employeeId] as const,

  variableLines: (scope: string) => ['variableLines', scope] as const,
  payrollProfile: () => ['payrollProfile'] as const,
  wpsSubmission: (runId: string) => ['wpsSubmission', runId] as const,
  identifiers: (employeeId: string) => ['identifiers', employeeId] as const,
  complianceSnapshot: (employeeId: string) => ['complianceSnapshot', employeeId] as const,
  expiringIdentifiers: (days: number) => ['expiringIdentifiers', days] as const,
  bankAccounts: (employeeId: string) => ['bankAccounts', employeeId] as const,

  performanceCycles: () => ['performanceCycles'] as const,
  performanceGoals: (cycleId: string, employeeId?: string) =>
    employeeId ? ['performanceGoals', cycleId, employeeId] : ['performanceGoals', cycleId] as const,

  payrollRuns: () => ['payrollRuns'] as const,
  payrollTemplates: () => ['payrollTemplates'] as const,
  payslips: (runId: string) => ['payslips', runId] as const,
  myPayslips: () => ['myPayslips'] as const,
  salaryStructures: (employeeId: string) => ['salaryStructures', employeeId] as const,

  expiringDocs: (days: number) => ['expiringDocs', days] as const,
  workflowTemplates: () => ['workflowTemplates'] as const,
  workflowInstances: (employeeId?: string) => employeeId ? ['workflowInstances', employeeId] : ['workflowInstances'] as const,

  openTickets: (employeeId: string) => ['openTickets', employeeId] as const,
  issuedItems: (employeeId: string) => ['issuedItems', employeeId] as const,

  pendingInvitations: (orgId: string) => ['pendingInvitations', orgId] as const,

  notifications: () => ['notifications'] as const,

  myDepartment: () => ['myDepartment'] as const,
} as const;
